import moment from 'moment';
// Get visible expenses

export default (expenses, { text = '', sortBy = 'date', startDate = undefined, endDate = undefined } = {}) => {
  let initialValue = 0
  return expenses.filter((expense) => {
    const createdAtMoment = moment(expense.createdAt);
    const startDateMatch = startDate ? startDate.isSameOrBefore(createdAtMoment, 'day') : true;
    const endDateMatch = endDate ? endDate.isSameOrAfter(createdAtMoment, 'day') : true;
    const textMatch = expense.description.toLowerCase().includes(text.toLowerCase());
    return startDateMatch && endDateMatch && textMatch;
  }).reduce(
    (accumulator, currentValue) => accumulator + currentValue.amount
    , initialValue
  )
};



// WEBPACK FOOTER //
// ./src/selectors/expenses-total.js